import React, {useState} from 'react'
import { 
    Layout,
    Col, 
    Row,
    // Button,
    // Dropdown, 
    // Space,
    // Modal,
    Select,
    Form,
    Input,
    // Tabs,
    // DatePicker
} from 'antd';
// import { useNavigate } from 'react-router-dom';
// import { ExclamationCircleFilled } from '@ant-design/icons';
// import { MoreVert  } from '@mui/icons-material';
import Navbar from '../../Components/Navbar/Navbar'
import AntDTable from '../../Components/Table/AntDTable';
// import { DatePicker } from 'antd';
// const { RangePicker } = DatePicker;
// const { TabPane } = Tabs;
const { Item } = Form;
const { Search } = Input;
const { Option } = Select;
// const { confirm } = Modal;

const ExhibitorPaymentReport = () => {
    const [filterConfig, setFilterConfig] = useState({
        payment_id: "",
        type: "tenant",
        status: "open",
    })

    const data = [
        {
          key: '1',
          tenant: 'John Brown',
          payment_no: '1',
          payment_date: 'Jan 2 2024',
          amount: '12 000',
          remark: 'remark1',
        },
        {
          key: '2',
          tenant: 'Jim Green',
          payment_no: '2',
          payment_date: 'Jan 9 2024',
          amount: '15 000',
          remark: 'remark2',
        },
        {
          key: '3',
          tenant: 'Joe Black',
          payment_no: '3',
          payment_date: 'Jan 6 2024',
          amount: '23 000',
          remark: 'remark3',
        },
        {
          key: '4',
          tenant: 'Jim Red',
          payment_no: '4',
          payment_date: 'Jan 1 2024',
          amount: '51 000',
          remark: 'remark4',
        },
    ];
  
    const onSearch = (e) => {
        setFilterConfig((prev) => (
          {
            ...prev,
            search: e.target.value || ''
          }
        ));
    };    
    return (
        <Layout className='page'>
            <Navbar navKey={'exhibitors_payment_report'}/>
            <Layout className='content-container'>
                <Row>
                    <Col span={24} className='header-container p-4'>
                        EXHIBITOR PAYMENT REPORT
                    </Col>
                </Row>
                <Row>
                    <Col span={12}>
                        <Row>
                            <Col span={12} className='p-4'>
                                <Item
                                    // label="Supplier Tradename"
                                    name="supplier_tradename"
                                    rules={[{ required: true, message: 'Please select your Tradename' }]} // Adjusted message
                                >
                                    <Select placeholder="Month">
                                        <Option value="property1">January</Option>
                                        <Option value="property2">Februaru</Option>
                                        <Option value="property2">March</Option>
                                        {/* Add more options as needed */}
                                    </Select>
                                </Item>
                            </Col>
                            <Col span={12} className='p-4'>
                                <Item
                                    // label="Supplier Tradename"
                                    name="supplier_tradename"
                                    rules={[{ required: true, message: 'Please select your Tradename' }]} // Adjusted message
                                >
                                    <Select placeholder="Year">
                                        <Option value="property1">2024</Option>
                                        <Option value="property2">2023</Option>
                                        <Option value="property2">2022</Option>
                                        {/* Add more options as needed */}
                                    </Select>
                                </Item>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={12} align='end' className='p-4'>
                        <Search placeholder="input search text" size='medium' allowClear onSearch={onSearch} style={{ width: 250 }} />
                    </Col>
                </Row>
                <Row className='page-content'>
                    <Col span={24}>
                        <AntDTable
                            tableHeaders={[
                            "Exhibitor Name",
                            "Billing Total",
                            "Payment Amount",
                            "Payment Type",
                            "Payment Date",
                            ]}
                            headerSelector={[
                            "payment_no",
                            "tenant",
                            "payment_date",
                            "amount",
                            "remark",
                            ]}
                            tableData={data}
                            // ActionBtn={(row) => ActionBtn(row)}
                            withAction={false}
                            // loading={showLoader}
                            // isClickable={true}
                            // rowClickPath={"/patients/profile"}
                            tablePages={10}
                            // handleTableChange={handleTableChange}
                            // filterConfig={filterConfig}
                            // totalSize={totalSize}
                            isSearch={true}
                        />
                    </Col>
                </Row>
            </Layout>
        </Layout>
    )
}

export default ExhibitorPaymentReport

